module.exports = "/_next/static/images/eshop-rychle-ff3d64341fffac89946a4223bb82f3f8.png";